import { useCallback, useState } from "react"

export type useToggleYields = {
  open: boolean
  onOpen: () => void
  onClose: () => void
  onToggle: () => void
  setValue: (value: boolean) => void
}

export function useToggle(initial?: boolean): useToggleYields {
  const [open, set] = useState<boolean>(() => !!initial)
  const onOpen = useCallback(() => {
    set(true)
  }, [set])
  const onClose = useCallback(() => {
    set(false)
  }, [set])
  const onToggle = useCallback(() => {
    set((s) => !s)
  }, [set])
  const setValue = useCallback(
    (value: boolean) => {
      set(value)
    },
    [set],
  )

  return {
    open,
    onOpen,
    onClose,
    onToggle,
    setValue,
  }
}
